import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import AddToCartButtonPage from "@faire/prototype-playground/workspace/cc/add-to-cart-button";
import AppCartAnimationPage from "@faire/prototype-playground/workspace/cc/app-cart-animation";
import BrandPageCopyPage from "@faire/prototype-playground/workspace/cc/brand-page-copy";
import FeedContentExplorationsR2Page from "@faire/prototype-playground/workspace/cc/feed-content-explorations-r-2";
import LiquidGlassIosPage from "@faire/prototype-playground/workspace/cc/liquid-glass-ios";
import NativePdpAtcStepperPage from "@faire/prototype-playground/workspace/cc/pdp-atc-stepper";
import NativePdpAtcPage from "@faire/prototype-playground/workspace/cc/pdp-explorations-native-pdp-atc";
import SavedProductsCartPage from "@faire/prototype-playground/workspace/cc/saved-products-cart";
import SavedProductsAllCollectionsPage from "@faire/prototype-playground/workspace/cc/saved-products-cart/AllCollectionsPage";
import SavedProductsCartCartPage from "@faire/prototype-playground/workspace/cc/saved-products-cart/CartRoute";
import SavedProductsCollectionsPage from "@faire/prototype-playground/workspace/cc/saved-products-cart/CollectionsPage";
import SavedProductsCollectionDetailPage from "@faire/prototype-playground/workspace/cc/saved-products-cart/CollectionDetailPage";
import { withCompass } from "../../components/compass/withCompass";

const DiscoveryFeedHomeContent = withCompass(
  () => import("../../components/DiscoveryFeedHomeContent")
);
const GlobalNavLayout = lazy(() => import("../../components/GlobalNavLayout"));
const RetailerLayout = withCompass(() => import("../../components/RetailerLayout"));
const SaveToCollectionPage = withCompass(
  () => import("@faire/prototype-playground/workspace/cc/save-to-collection")
);

const CategoryMenuStylingPage = withCompass(
  () => import("../../pages/CategoryMenuStylingPage")
);
const FeedContentExplorationsPage = withCompass(
  () => import("../../pages/FeedContentExplorationsPage")
);
const PDPRefreshIterationPage = withCompass(
  () => import("../../pages/PDPRefreshIterationPage")
);
const PdpContentIterationsPage = withCompass(
  () => import("../../pages/PdpContentIterationsPage")
);
const PdpInfiniteScrollMobilePage = lazy(
  () => import("../../pages/PdpInfiniteScrollMobilePage")
);
const PdpRefreshIterationR2Page = withCompass(
  () => import("../../pages/PDPRefreshIterationR2Page")
);
const BrandPageExplorationPage = withCompass(
  () => import("../../pages/BrandPageExplorationPage")
);
const BrandPageFloatingSidebarPage = withCompass(
  () => import("../../pages/BrandPageFloatingSidebarPage")
);
const PDPRefreshIterationR3Page = withCompass(
  () => import("../../pages/PDPRefreshIterationR3Page")
);
const PdpVerifiedPricingPage = withCompass(
  () => import("@faire/prototype-playground/workspace/cc/verified-pricing")
);
const TrendsHubPage = withCompass(() => import("../../pages/TrendsHubPage"));
const TrendLayoutRefinementPage = withCompass(
  () => import("../../pages/TrendLayoutRefinementPage")
);
const ProductDetailPage = withCompass(
  () => import("../../pages/ProductDetailPage")
);
const GlobalNavigationFeedContent = withCompass(() =>
  import("../../pages/GlobalNavigationPage").then((m) => ({
    default: m.GlobalNavigationFeedContent,
  }))
);

export function ChrisChappelleRoutes() {
  return (
    <Switch>
      <Route path="/cc/add-to-cart-button" component={AddToCartButtonPage} />
      <Route path="/cc/app-cart-animation" component={AppCartAnimationPage} />
      <Route path="/cc/brand-page-copy" component={BrandPageCopyPage} />
      <Route
        path="/cc/feed-content-explorations"
        component={FeedContentExplorationsPage}
      />
      <Route
        path="/cc/category-menu-styling"
        component={CategoryMenuStylingPage}
      />
      <Route
        path="/cc/homepage"
        render={() => (
          <RetailerLayout>
            <DiscoveryFeedHomeContent />
          </RetailerLayout>
        )}
      />
      <Route
        exact
        path="/cc/global-navigation"
        render={() => (
          <GlobalNavLayout>
            <GlobalNavigationFeedContent />
          </GlobalNavLayout>
        )}
      />
      <Route
        path="/cc/global-navigation/pdp"
        render={() => (
          <GlobalNavLayout>
            <ProductDetailPage contentOnly />
          </GlobalNavLayout>
        )}
      />
      <Route path="/cc/grid-refinement" component={TrendLayoutRefinementPage} />
      <Route path="/cc/liquid-glass-ios" component={LiquidGlassIosPage} />
      <Route
        path="/cc/pdp-infinite-scroll-mobile"
        component={PdpInfiniteScrollMobilePage}
      />
      <Route
        path="/cc/pdp-content-iterations"
        component={PdpContentIterationsPage}
      />
      <Route
        path="/cc/pdp-refresh-iteration"
        component={PDPRefreshIterationPage}
      />
      <Route
        path="/cc/pdp-refresh-iteration-r2"
        component={PdpRefreshIterationR2Page}
      />
      <Route
        path="/cc/brand-page-exploration"
        component={BrandPageExplorationPage}
      />
      <Route
        path="/cc/brand-page-floating-sidebar"
        component={BrandPageFloatingSidebarPage}
      />
      <Route path="/cc/feed-content-explorations-r-2" component={FeedContentExplorationsR2Page} />
      <Route path="/cc/pdp-atc-stepper" component={NativePdpAtcStepperPage} />
      <Route path="/cc/pdp-explorations-native-pdp-atc" component={NativePdpAtcPage} />
      <Route
        path="/cc/pdp-refresh-iteration-r3"
        component={PDPRefreshIterationR3Page}
      />
      <Route path="/cc/save-to-collection" component={SaveToCollectionPage} />
      <Route
        path="/cc/saved-products-cart/all-collections"
        component={SavedProductsAllCollectionsPage}
      />
      <Route
        path="/cc/saved-products-cart/collections/:collectionId"
        component={SavedProductsCollectionDetailPage}
      />
      <Route
        path="/cc/saved-products-cart/collections"
        component={SavedProductsCollectionsPage}
      />
      <Route
        path="/cc/saved-products-cart/cart"
        component={SavedProductsCartCartPage}
      />
      <Route path="/cc/saved-products-cart" component={SavedProductsCartPage} />
      <Route path="/cc/trends-hub" component={TrendsHubPage} />
      <Route path="/cc/verified-pricing" component={PdpVerifiedPricingPage} />
    </Switch>
  );
}

export const slug = "cc";
